module.exports = function getResource(label, vars = []) {
    let resources = {
        add: 'Ajouter'
    };

    return resources[label];
};
